import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activitystatus',
  templateUrl: './activitystatus.component.html',
  styleUrls: ['./activitystatus.component.scss']
})
export class ActivitystatusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
